import { render, staticRenderFns } from "./TambahRoleMenu.vue?vue&type=template&id=78aa2afc&scoped=true"
import script from "./TambahRoleMenu.vue?vue&type=script&lang=js"
export * from "./TambahRoleMenu.vue?vue&type=script&lang=js"
import style0 from "./TambahRoleMenu.vue?vue&type=style&index=0&id=78aa2afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aa2afc",
  null
  
)

export default component.exports